export default "__VITE_PUBLIC_ASSET__c08b9f12__"